import { StyleSheet, View } from 'react-native';
import { calcSizeForTv } from 'utils/index';

import { SIMPLE_KEYBOARD } from './helpers/keyboardItems';

import Button from 'components/Button';
import Grid from 'components/Grid';

type SimpleKeyboardProps = { onHandleKeyPress: Function };

const SimpleKeyboard: React.FC<SimpleKeyboardProps> = ({ onHandleKeyPress }) => {
  return (
    <View style={styles.container}>
      <Grid
        numColumns={6}
        data={SIMPLE_KEYBOARD}
        gap={calcSizeForTv(6)}
        isPlaceholderNeeded={false}
        renderItem={(keyItem) => (
          <Button
            role="button"
            useTVFocus
            hasTVPreferredFocus={keyItem.value === 'a'}
            variant="solid"
            style={{
              ...styles.keyButton,
              height: calcSizeForTv(52),
              justifyContent: 'center',
              alignItems: 'center',
              width: keyItem.columns
                ? calcSizeForTv(keyItem.columns * 52 + (keyItem.columns - 1) * 4)
                : calcSizeForTv(52),
            }}
            onPress={() => onHandleKeyPress(keyItem)}
            textStyle={styles.keyText}>
            {keyItem.symbol}
          </Button>
        )}
      />
    </View>
  );
};

export default SimpleKeyboard;

const styles = StyleSheet.create({
  container: {
    width: calcSizeForTv(352),
  },
  keyButton: {
    paddingHorizontal: 0,
    borderWidth: 1,
    borderColor: 'rgba(255, 255, 255, 0.2)',
    backgroundColor: 'rgba(6, 113, 224, 0.07)',
    borderRadius: 2,
  },
  keyText: {
    fontSize: calcSizeForTv(20),
  },
});
